import React, {Component} from "react";
import Paper from 'material-ui/Paper';

import "../App.css";


class Source extends Component {
    style = {
        margin: 20,
        fontFamily: 'monospace',
        padding: 12
    };

    render() {
        return (
            <div className="content">
                On this page you can find extra information and source code for the book
                Head First Android Development.

                You can download the source code in&nbsp;
                <a href="https://github.com/dogriffiths/HeadFirstAndroid2ndEdition/zipball/master">zip</a>
                &nbsp;or &nbsp;<a href="https://github.com/dogriffiths/HeadFirstAndroid2ndEdition/tarball/master">tar.gz</a>
                &nbsp;format. Or, if you have <a href="http://www.git-scm.com/">git</a> installed, you can get
                your own copy of the
                &nbsp;<a href="https://github.com/dogriffiths/HeadFirstAndroid2ndEdition">source code</a>&nbsp;
                repository by typing this on the command line:

                <Paper style={this.style} zDepth={1} >
                    $ git clone https://github.com/dogriffiths/HeadFirstAndroid2ndEdition.git<br/>
                    $ cd HeadFirstAndroid2ndEdition<br/>
                    $ ls
                </Paper>

                And don't forget: we're going to continue adding useful information to the
                &nbsp;<a href="https://github.com/dogriffiths/HeadFirstAndroid/wiki">Head First Android Wiki</a>.
            </div>
        );
    }
}

export default Source;



// WEBPACK FOOTER //
// ./src/containers/Source.js